const root = 'resetPasswordForm'

export const TestId = {
  emailInput: `${root}-emailInput`,
  submitButton: `${root}-submitButton`,
}
